import React from 'react';

import { Row, Col } from 'antd';
import LeadActivitiesTable from './LeadActivities/LeadActivitiesTable';
import { ParentProfileStyles, ParentAndChildrenInfoStyles } from './styles';
import ContactInfo from './ContactInfo';
import ParentApplications from './Applications';
import ParentEnquiries from './Enquiries';
import ChildrenInfo from './ChildrenInfo';

const ParentProfile = () => (
  <ParentProfileStyles>
    <Row gutter={[24, 24]}>
      <Col xl={6} lg={8} md={24} xs={24}>
        <ParentAndChildrenInfoStyles>
          <ContactInfo />
          <ChildrenInfo />
        </ParentAndChildrenInfoStyles>
      </Col>

      <Col xl={18} lg={16} md={24} xs={24}>
        <div>
          <ParentApplications />
        </div>
        <div className="mt-24">
          <ParentEnquiries />
        </div>
        <div className="mt-24">
          <LeadActivitiesTable />
        </div>
      </Col>
    </Row>
  </ParentProfileStyles>
);

export default ParentProfile;
